import { Fragment } from 'react';

import useOmeHostLoading from './UseOmeHostLoading';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const OmeHostLoading = ({redirectNavLink}) => {
  const {
    isLoading
  } = useOmeHostLoading(redirectNavLink);

  return (
    <Fragment>
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default OmeHostLoading;